import React from 'react';
import { useMusic } from './MusicContext';

function MusicToggle() {
  const { isPlaying, toggleMusic } = useMusic();

  return (
    <button
      onClick={toggleMusic}
      className='fixed top-[15px] left-[15px] md:top-auto md:bottom-[30px] md:left-auto md:right-[30px] z-[9999] cursor-pointer bg-transparent border-none p-0'
      aria-label={isPlaying ? 'Pause music' : 'Play music'}
    >
      <div className='relative w-[50px] h-[50px]'>
        <img
          src={process.env.PUBLIC_URL + '/musicbg.png'}
          alt=''
          className='absolute inset-0 w-full h-full object-contain'
        />
        <img
          src={
            process.env.PUBLIC_URL +
            (isPlaying ? '/musicon.png' : '/musicoff.png')
          }
          alt={isPlaying ? 'Music On' : 'Music Off'}
          className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60%] h-[60%] object-contain'
        />
      </div>
    </button>
  );
}

export default MusicToggle;
